import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { getLabel } from '@/helpers/Utils';

export const fetchFormControl = createAsyncThunk(
  'formControl/fetchFormControl',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetFormControl();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: getLabel(item.nameEn, item.nameAr),
          value: item.id,
          isNumericDrowpDown: item.isNumericDrowpDown,
          isDrowpDown: item.isDrowpDown,
        })) ?? [];
      return [...mappedData];
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  formControlList: [],
  loading: false,
  error: '',
};

const formControlSlice = createSlice({
  name: 'formControl',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFormControl.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFormControl.fulfilled, (state, action) => {
        state.loading = false;
        state.formControlList = action.payload;
        state.error = '';
      })
      .addCase(fetchFormControl.rejected, (state, action) => {
        state.loading = false;
        state.formControlList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default formControlSlice.reducer;
